import { API_URL as ENDPOINT } from "../config/env";


export async function ContratosGet(token) {
  return fetch(`${ENDPOINT}ContratosGet`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "get",
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}

function contratoToFormData(data) {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (key === "documento" && !(value instanceof File)) {
      return;
    }
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });
  return formData;
}

export async function ContratosAdd(data, token) {
  return fetch(`${ENDPOINT}ContratosAdd`, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: contratoToFormData(data),
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}

export async function ContratosUpdate(data, token) {
  return fetch(`${ENDPOINT}ContratosUpdate`, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: contratoToFormData(data),
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}

export async function ContratosDelete(data, token) {
  return fetch(`${ENDPOINT}ContratosDelete`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}
